import { EtcaRedirectContent } from '@features/etca-redirect/components/content/EtcaRedirectContent';
import { useEtcaRedirect } from '@features/etca-redirect/hooks/use-etca-redirect/useEtcaRedirect';
import { HeaderOnlyLayout } from '@layouts/header-only-layout/HeaderOnlyLayout';
import { AppLoader } from '@shared/components/app-loader/AppLoader';
import * as React from 'react';

const EtcaRedirectPage = React.memo((): React.ReactElement => {
  const { state, retry } = useEtcaRedirect();

  if (state.step === 'loading') {
    return <AppLoader />;
  }

  return (
    <HeaderOnlyLayout>
      <EtcaRedirectContent state={state} retry={retry} />
    </HeaderOnlyLayout>
  );
});

EtcaRedirectPage.displayName = 'EtcaRedirectPage';

export { EtcaRedirectPage };
